"use client";

import Image, { StaticImageData } from "next/image";
import CommonSubtitle from "@/components/common/CommonSubtitle";
import CommonTitle from "@/components/common/CommonTitle";
import bgBoxImage from "@/assets/images/features/profit-box-bg.svg";

export interface ProfitFeaturesType {
  context: string;
  title: string;
  description: string;
  features: {
    title: string;
    description: string;
    image: StaticImageData;
  }[];
}

const ProfitFeatures = ({
  profitFeatures,
}: {
  profitFeatures: ProfitFeaturesType;
}) => {
  return (
    <section className="bg-[#EFEFF6] py-12 xl:py-20">
      <div className="container mx-auto px-4">
        <div className="mb-8 text-center xl:mb-10">
          <div className="mx-auto mb-2 inline-flex w-fit rounded-full bg-white px-3 py-1 text-sm font-semibold">
            <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
              {profitFeatures.context}
            </span>
          </div>
          <CommonTitle
            as="h2"
            color="#202020"
            fontSizeClass="text-[24px] lg:text-[32px] xl:text-[36px]"
            fontWeightClass="font-semibold"
            maxWidthClass="mx-auto max-w-4xl"
          >
            {profitFeatures.title}
          </CommonTitle>
          <CommonSubtitle>
            <span className="mx-auto mt-3 block max-w-2xl">
              {profitFeatures.description}
            </span>
          </CommonSubtitle>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {profitFeatures.features.map((feature, index) => (
            <div
              key={index}
              className="relative flex flex-col overflow-hidden rounded-xl p-4 text-white shadow-lg xl:p-6 h-full"
              style={{
                background: `url(${bgBoxImage.src})`,
                backgroundColor: "#ffffff",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
              <h3 className="mb-2 text-lg font-semibold xl:text-xl mt-4">
                {feature.title}
              </h3>
              <p className="mb-4 flex-1 text-sm leading-relaxed text-white/90 xl:text-base">
                {feature.description}
              </p>
              <div className="relative mt-auto">
                <div className="overflow-hidden">
                  <Image
                    src={feature.image}
                    alt={feature.title}
                    className="h-full w-full object-cover"
                    priority={feature.title === "Source-Backed"}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProfitFeatures;
